import {Card, DataStatus} from 'platform/components';
import {Box} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, Section} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {suffixTestId, TestIdProps} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface CostCorrectionsProps extends TestIdProps {
  isIssueNoteLoading: boolean;
}

export function CostCorrections(props: CostCorrectionsProps) {
  const {issueNoteId} = useWarehouseParams();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {issueNoteId}]),
    [issueNoteId]
  );

  return (
    <Section isFullHeight data-testid={suffixTestId('wrapper', props)}>
      <DataStatus isLoading={props.isIssueNoteLoading}>
        <Card isFullHeight title={i18n.t('general.labels.costCorrections')}>
          <Box height="100%">
            <DmsDataGrid
              gridCode="warehouse-issue-note-cost-corrections"
              queryModifier={queryModifier}
              data-testid="costCorrectionsDatagrid"
            />
          </Box>
        </Card>
      </DataStatus>
    </Section>
  );
}
